"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Scan/ScanPage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _forms = require('shared/services/forms');
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _store = require('web/store');
var _Form = require('web/components/Form');

var _Gated = require('../Gated'); var _Gated2 = _interopRequireDefault(_Gated);
var _common = require('../common');
var _icons = require('../icons');
var _importRules = require('../Import/importRules');
var _pages = require('../Import/pages');
var _useFormsGate = require('../useFormsGate');
var _ServiceScreen = require('web/screens/ServiceScreen'); var _ServiceScreen2 = _interopRequireDefault(_ServiceScreen);
require('../forms.scss');









let nextShotId = 1

/* Screen 5, in the phone's browser: photograph each page with the phone's
 * own camera, then upload them into a draft (the link's, or a new one). */
const ScanFlow = ({ orgKey, formKey }) => {
  const inputRef = _react.useRef(null)
  // The page a new photo replaces, or null to add one.
  const retakeRef = _react.useRef(null)
  const [shots, setShots] = _react.useState([])
  const [name, setName] = _react.useState.call(void 0, '')
  const [phase, setPhase] = _react.useState({ name: 'taking' })
  const [error, setError] = _react.useState(null)
  const [isReading, setIsReading] = _react.useState.call(void 0, false)

  const shotsRef = _react.useRef.call(void 0, shots)
  shotsRef.current = shots
  _react.useEffect.call(void 0, () => () => shotsRef.current.forEach(s => URL.revokeObjectURL(s.url)), [])

  const takePhoto = (replace) => {
    retakeRef.current = replace
    _optionalChain([inputRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.click, 'call', _3 => _3()])
  }

  const onPhoto = async (e) => {
    const file = _optionalChain([e, 'access', _4 => _4.target, 'access', _5 => _5.files, 'optionalAccess', _6 => _6[0]])
    e.target.value = ''
    if (!file) return
    setError(null)
    setIsReading(true)
    const jpeg = await _pages.photoToJpeg.call(void 0, file).catch(() => null)
    setIsReading(false)
    if (!jpeg) {
      setError(_importRules.unreadablePhoto.call(void 0, file.name))
      return
    }
    const shot = { id: nextShotId++, jpeg, url: URL.createObjectURL(jpeg) }
    const replace = retakeRef.current
    setShots(prev => {
      if (replace == null) return [...prev, shot]
      const old = prev[replace]
      if (old) URL.revokeObjectURL(old.url)
      return prev.map((s, i) => i === replace ? shot : s)
    })
  }

  const upload = async () => {
    setError(null)
    setPhase({ name: 'uploading', done: 0 })
    try {
      let done = 0
      const keys = await Promise.all(shots.map((s, i) => _pages.uploadPage.call(void 0, s.jpeg, `scan-page-${i + 1}.jpg`).then(key => {
        setPhase({ name: 'uploading', done: ++done })
        return key
      })))
      const { Form } = await _forms.addFormPages.call(void 0, formKey
        ? { OrgKey: orgKey, FormKey: formKey, PageFileKeys: keys }
        : { OrgKey: orgKey, Name: name.trim(), PageFileKeys: keys })
      setPhase({ name: 'sent', formName: Form.Name })
    } catch (err) {
      setPhase({ name: 'taking' })
      setError(_forms.formsErrorText.call(void 0, err, "The pages couldn't be uploaded. Check your connection and try again."))
    }
  }

  const scanAnother = () => {
    shots.forEach(s => URL.revokeObjectURL(s.url))
    setShots([])
    setName('')
    setError(null)
    setPhase({ name: 'taking' })
    // Another form is a new draft.
    if (formKey) _store.history.replace(_routes.makeRoute.call(void 0, _routes2.default.FORMS.SCAN, { orgKey }))
  }

  if (phase.name === 'sent') {
    return (
      _react2.default.createElement('div', { className: "forms-scan forms-scan--done" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement('span', { className: "forms-scan--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, _react2.default.createElement(_icons.CheckIcon, { size: 28, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}} ))
        , _react2.default.createElement('h1', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, "Sent to Forms"  )
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 105}},  phase.formName , " is in the Library as a draft. BloomText is finding its fields now."             )
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, "Check the fields and finish it on a computer."        )
        , _react2.default.createElement(_Form.Button, { isOutlined: true, onClick: scanAnother, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}, "Scan another form"  )
      )
    )
  }

  const isUploading = phase.name === 'uploading'
  const isFull = shots.length >= _importRules.MAX_PAGES
  return (
    _react2.default.createElement('div', { className: "forms-scan", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
      , _react2.default.createElement('header', { className: "forms-scan--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}
        , _react2.default.createElement('button', { type: "button", className: "forms-scan--back", 'aria-label': "Back to Chats"  , onClick: () => _store.history.push(_routes2.default.INBOX.ROOT), __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
          , _react2.default.createElement(_icons.ChevronLeftIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}} )
        )
        , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
          , _react2.default.createElement('h1', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}, "Scan a paper form"   )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 122}},  isUploading ? `Uploading ${_common.pluralize.call(void 0, shots.length, 'page', 'pages')}` : _common.pluralize.call(void 0, shots.length, 'page', 'pages') )
        )
      )
      , _react2.default.createElement('input', {
        ref: inputRef,
        type: "file",
        accept: "image/*",
        capture: "environment",
        className: "forms-scan--input",
        onChange: onPhoto, __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
      )
      , _react2.default.createElement('div', { className: "forms-scan--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
        ,  shots.length > 0 && (
          _react2.default.createElement('div', { className: "forms-scan--shots", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
            ,  shots.map((s, i) => (
              _react2.default.createElement('button', {
                key: s.id,
                type: "button",
                className: "forms-scan--shot",
                'aria-label': `Retake page ${i + 1}`,
                disabled: isUploading,
                onClick: () => takePhoto(i), __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}

                , _react2.default.createElement('img', { src: s.url, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}} )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}, "Page " ,  i + 1 )
              )
            ))
          )
        )
        ,  isUploading && (
          _react2.default.createElement('span', { className: "forms-progress", __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, _react2.default.createElement('span', { style: { width: `${(phase.done / Math.max(1, shots.length)) * 100}%` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}} ))
        )
        ,  shots.length > 0 && !isUploading && _react2.default.createElement('p', { className: "forms-scan--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}, "Tap a page to retake it."     ) 
        ,  shots.length === 0 && (
          _react2.default.createElement('p', { className: "forms-scan--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}, "Lay the page flat in good light and take a photo of each page."             )
        )
        ,  !formKey && !isUploading && (
          _react2.default.createElement('label', { className: "forms-scan--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}, "Name")
            , _react2.default.createElement('input', { value: name, maxLength: 200, placeholder: "Untitled form" , onChange: e => setName(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}} )
          )
        )
        ,  error && _react2.default.createElement('p', { role: "alert", className: "forms-scan--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}},  error ) 
        ,  shots.length === 0 && (
          _react2.default.createElement('div', { className: "forms-scan--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
            , _react2.default.createElement(_icons.FormsIcon, { size: 40, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}, "No pages yet"  )
          )
        )
      )
      ,  !isUploading && (
        _react2.default.createElement('footer', { className: "forms-scan--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
          , _react2.default.createElement(_Form.Button, { isOutlined: true, isDisabled: isFull, isLoading: isReading, onClick: () => takePhoto(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}
            , _react2.default.createElement(_icons.CameraIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 175}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 176}},  shots.length ? 'Add page' : 'Take photo' )
          )
          , _react2.default.createElement(_Form.Button, { isDisabled: !shots.length || isReading, onClick: () => { upload() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 179}},  shots.length ? `Upload ${_common.pluralize.call(void 0, shots.length, 'page', 'pages')}` : 'Upload' )
          )
        )
      )
    )
  )
}

/* #/forms/scan/{orgKey}[/{formKey}], for signed-in staff of that org. */
const ScanPage = ({ match }) => {
  const { orgKey, formKey = null } = match.params
  const gate = _useFormsGate.useFormsGate.call(void 0, orgKey)
  if (gate === 'not-member') {
    return (
      _react2.default.createElement('div', { className: "forms-scan forms-scan--done" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}
        , _react2.default.createElement('h1', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}, "This scan link isn't for you"     )
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}, "It belongs to an organization you aren't a member of. Sign in with your work account, or scan the code again from your own computer."                        )
        , _react2.default.createElement(_Form.Button, { isOutlined: true, onClick: () => _store.history.push(_routes2.default.INBOX.ROOT), __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}, "Go to Chats"  )
      )
    )
  }
  // The scan route renders outside the app shell, so it loads you, your
  // teams and your orgs itself (ServiceScreen does that inside the shell).
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_ServiceScreen2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 204}} )
      , _react2.default.createElement(_Gated2.default, { gate: gate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}, _react2.default.createElement(ScanFlow, { key: `${orgKey}/${_nullishCoalesce(formKey, () => ( ''))}`, orgKey: orgKey, formKey: formKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}} ))
    )
  )
}

exports. default = ScanPage
